import Splide from '@splidejs/splide';

(function($, Drupal) {
  Drupal.behaviors.splide = {
    attach: function(context, settings) {
      // Declare variables
      let $spide_carousels_default,
          $splide_settings,
          $splide_breakpoints;

      $spide_carousels_default = $('.splide-carousel');

      // Splide initialization
      function create_carousel_default($block, i) {
        // Set ID for each carousel for easy selection
        const $carousel_id = $block.find('.splide').first().attr('id');

        // Default splide settings, altered based on conditionals below
        $splide_settings = {
          type: 'loop',
          rewind: true,
          pagination: true,
          arrows: true,
          perPage: 1,
          lazyLoad: 'sequential',
          wheel: false
        };

        // Default  breakpoints, altered based on conditionals below
        $splide_breakpoints = {
          768: {
            perPage: 1
          }
        };

        if ($block.hasClass('issues')) {
          // Default splide settings, altered based on conditionals below
          $splide_settings = {
            type: 'loop',
            rewind: true,
            pagination: false,
            arrows: false,
            perPage: 4,
            lazyLoad: 'sequential',
            wheel: false,
            gap: 30,
            destroy: true
          };
          // Default  breakpoints, altered based on conditionals below
          $splide_breakpoints = {
            820: {
              perPage: 1,
              arrows: true,
              destroy: false
            }
          };
        }

        if ($block.hasClass('diamond')) {
          // Default splide settings, altered based on conditionals below
          $splide_settings = {
            type: 'fade',
            rewind: true,
            pagination: false,
            arrows: true,
            perPage: 1,
            lazyLoad: 'sequential',
            wheel: false,
            gap: 0,
            destroy: false,
            speed: 0
          };
          // Default  breakpoints, altered based on conditionals below
          $splide_breakpoints = {
            768: {
              perPage: 1,
              arrows: true,
              destroy: false,
              pagination: false
            }
          };
        }

        if ($block.hasClass('trending-articles')) {
          // Default splide settings, altered based on conditionals below
          $splide_settings = {
            type: 'slide',
            rewind: true,
            pagination: false,
            arrows: true,
            perPage: 4,
            lazyLoad: 'sequential',
            wheel: false,
            gap: 0,
            destroy: false
          };
          // Default  breakpoints, altered based on conditionals below
          $splide_breakpoints = {
            768: {
              perPage: 1,
              arrows: true,
              destroy: false,
              pagination: false
            },
            1024: {
              perPage: 2,
              arrows: true,
              destroy: false,
              pagination: false
            }
          };
        }

        // Set splide settings after logic has been applied
        Splide.defaults = $splide_settings;

        // Break point sets all carousels to show one item on screens 768px and smaller
        let $main_carousel = new Splide('#' + $carousel_id, {
          breakpoints: $splide_breakpoints
        });

        $main_carousel.mount();
      }

      function post_mount_diamond($block, i) {
        let $splide_slides = $($block).find('.splide__slide');

        // Inject pre and next slide images into current slide
        $splide_slides.each(function(j) {
          let $prev_slide, $next_slide, $current_slide;
          $current_slide = $(this).first();

          if ($current_slide.prev().length === 0) {
            $prev_slide = $splide_slides.last();
            $prev_slide.find('.media--type-image').eq(0).clone().prependTo($current_slide.find('.field--name-field-image').first());
          }
          else {
            $prev_slide = $current_slide.prev();
            $prev_slide.find('.media--type-image').eq(1).clone().prependTo($current_slide.find('.field--name-field-image').first());
          }

          if ($current_slide.next().length === 0) {
            $next_slide = $splide_slides.first();
            $next_slide.find('.media--type-image').eq(1).clone().appendTo($current_slide.find('.field--name-field-image').first());
          }
          else {
            $next_slide = $current_slide.next();
            $next_slide.find('.media--type-image').eq(0).clone().appendTo($current_slide.find('.field--name-field-image').first());
          }
        });

        // Inject text for prev and next slide titles on splide mount
        $('.prev-button').first().find('span').text($($block).find('.splide__slide').last().find('.field--name-field-title').first().text());
        $('.next-button').first().find('span').text($($block).find('.is-next').first().find('.field--name-field-title').first().text());

        // Change text of buttons on click
        $('.splide__arrow').on('click', function() {
          setTimeout(() => {
            update_diamond_button_text($block);
          }, 100);
        });
      }

      function update_diamond_button_text($block) {
        let $prev_text, $next_text, $splide_slides;
        $splide_slides = $($block).find('.splide__slide');
        if ($($block).find('.is-prev').length === 0) {
          $prev_text = $splide_slides.last().find('.field--name-field-title').first().text();
        }
        else {
          $prev_text = $($block).find('.is-prev').first().find('.field--name-field-title').first().text();
        }
        if ($($block).find('.is-next').length === 0) {
          $next_text = $splide_slides.first().find('.field--name-field-title').first().text();
        }
        else {
          $next_text = $($block).find('.is-next').first().find('.field--name-field-title').first().text();
        }
        $('.prev-button').first().find('span').text($prev_text);
        $('.next-button').first().find('span').text($next_text);
      }

      // Grab all splide carousels and initialize
      $spide_carousels_default.once().each(function(index) {
        create_carousel_default($(this), index);

        if ($(this).hasClass('diamond')) {
          post_mount_diamond($(this), index);
        }
      });
    }
  };
})(jQuery, Drupal);

